import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

const TeacherClasses = () => {
  const routes = all_routes;
  const [searchTerm, setSearchTerm] = useState("");
  const [filterGrade, setFilterGrade] = useState("all");

  // Mock data for teacher's classes
  const classesData = [
    {
      id: "1",
      code: "10A",
      subject: "Mathematics",
      grade: "10th",
      section: "A",
      room: "Room 201",
      studentsCount: 32,
      schedule: [
        { day: "Monday", time: "9:00 AM - 9:45 AM" },
        { day: "Wednesday", time: "10:00 AM - 10:45 AM" },
        { day: "Friday", time: "11:00 AM - 11:45 AM" },
      ],
      nextClass: "Monday, 9:00 AM",
      attendance: { present: 28, absent: 4, percentage: 87.5 },
      homework: { assigned: 5, pending: 2 },
      color: "primary",
    },
    {
      id: "2",
      code: "11B",
      subject: "Physics",
      grade: "11th",
      section: "B",
      room: "Lab 1",
      studentsCount: 28,
      schedule: [
        { day: "Tuesday", time: "8:30 AM - 9:15 AM" },
        { day: "Thursday", time: "10:00 AM - 10:45 AM" },
        { day: "Friday", time: "2:00 PM - 2:45 PM" },
      ],
      nextClass: "Tuesday, 8:30 AM",
      attendance: { present: 25, absent: 3, percentage: 89.3 },
      homework: { assigned: 3, pending: 1 },
      color: "success",
    },
    {
      id: "3",
      code: "9C",
      subject: "Mathematics",
      grade: "9th",
      section: "C",
      room: "Room 105",
      studentsCount: 30,
      schedule: [
        { day: "Monday", time: "11:00 AM - 11:45 AM" },
        { day: "Wednesday", time: "2:00 PM - 2:45 PM" },
        { day: "Thursday", time: "9:00 AM - 9:45 AM" },
      ],
      nextClass: "Monday, 11:00 AM",
      attendance: { present: 27, absent: 3, percentage: 90.0 },
      homework: { assigned: 4, pending: 3 },
      color: "warning",
    },
    {
      id: "4",
      code: "12A",
      subject: "Advanced Mathematics",
      grade: "12th",
      section: "A",
      room: "Room 301",
      studentsCount: 25,
      schedule: [
        { day: "Tuesday", time: "2:00 PM - 2:45 PM" },
        { day: "Friday", time: "9:00 AM - 9:45 AM" },
      ],
      nextClass: "Tuesday, 2:00 PM",
      attendance: { present: 23, absent: 2, percentage: 92.0 },
      homework: { assigned: 2, pending: 0 },
      color: "info",
    },
    {
      id: "5",
      code: "8B",
      subject: "Basic Mathematics",
      grade: "8th",
      section: "B",
      room: "Room 102",
      studentsCount: 35,
      schedule: [
        { day: "Monday", time: "1:00 PM - 1:45 PM" },
        { day: "Wednesday", time: "8:30 AM - 9:15 AM" },
        { day: "Thursday", time: "3:00 PM - 3:45 PM" },
      ],
      nextClass: "Monday, 1:00 PM",
      attendance: { present: 31, absent: 4, percentage: 88.6 },
      homework: { assigned: 6, pending: 4 },
      color: "secondary",
    },
  ];

  // Filter classes based on search and grade
  const filteredClasses = classesData.filter((cls) => {
    const matchesSearch =
      cls.code.toLowerCase().includes(searchTerm.toLowerCase()) ||
      cls.subject.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesGrade = filterGrade === "all" || cls.grade === filterGrade;
    return matchesSearch && matchesGrade;
  });

  const grades = ["all", "8th", "9th", "10th", "11th", "12th"];

  const getAttendanceColor = (percentage: number) => {
    if (percentage >= 90) return "success";
    if (percentage >= 80) return "warning";
    return "danger";
  };

  const renderClassCard = (classItem: any) => (
    <div key={classItem.id} className="card mb-4">
      <div className="card-header d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center">
          <div className={`avatar avatar-lg bg-${classItem.color} me-3`}>
            <span className="text-white fw-bold fs-4">{classItem.code}</span>
          </div>
          <div>
            <h5 className="mb-1">{classItem.subject}</h5>
            <p className="text-muted mb-0">
              Grade {classItem.grade} Section {classItem.section} •{" "}
              {classItem.room}
            </p>
          </div>
        </div>
        <div className="dropdown">
          <button
            className="btn btn-outline-secondary btn-sm dropdown-toggle"
            data-bs-toggle="dropdown"
          >
            Actions
          </button>
          <ul className="dropdown-menu">
            <li>
              <Link to={routes.attendanceTracker} className="dropdown-item">
                <i className="ti ti-user-check me-2"></i>Take Attendance
              </Link>
            </li>
            <li>
              <Link to={routes.manageHomework} className="dropdown-item">
                <i className="ti ti-book me-2"></i>Assign Homework
              </Link>
            </li>
            <li>
              <Link to={routes.gradeEntry} className="dropdown-item">
                <i className="ti ti-clipboard-list me-2"></i>Enter Grades
              </Link>
            </li>
            <li>
              <Link to={routes.alertParents} className="dropdown-item">
                <i className="ti ti-bell me-2"></i>Send Alert
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="card-body">
        {/* Class Stats */}
        <div className="row mb-3">
          <div className="col-md-3 col-sm-6">
            <div className="d-flex align-items-center">
              <div className="avatar avatar-sm bg-info-transparent me-2">
                <i className="ti ti-users text-info"></i>
              </div>
              <div>
                <h6 className="mb-0">{classItem.studentsCount}</h6>
                <small className="text-muted">Students</small>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-6">
            <div className="d-flex align-items-center">
              <div
                className={`avatar avatar-sm bg-${getAttendanceColor(
                  classItem.attendance.percentage
                )}-transparent me-2`}
              >
                <i
                  className={`ti ti-calendar-check text-${getAttendanceColor(
                    classItem.attendance.percentage
                  )}`}
                ></i>
              </div>
              <div>
                <h6 className="mb-0">{classItem.attendance.percentage}%</h6>
                <small className="text-muted">Attendance</small>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-6">
            <div className="d-flex align-items-center">
              <div className="avatar avatar-sm bg-warning-transparent me-2">
                <i className="ti ti-book text-warning"></i>
              </div>
              <div>
                <h6 className="mb-0">{classItem.homework.pending}</h6>
                <small className="text-muted">Pending HW</small>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-6">
            <div className="d-flex align-items-center">
              <div className="avatar avatar-sm bg-primary-transparent me-2">
                <i className="ti ti-clock text-primary"></i>
              </div>
              <div>
                <h6 className="mb-0 small">{classItem.nextClass}</h6>
                <small className="text-muted">Next Class</small>
              </div>
            </div>
          </div>
        </div>

        {/* Schedule */}
        <div className="mb-3">
          <h6 className="mb-2">Weekly Schedule</h6>
          <div className="d-flex flex-wrap gap-2">
            {classItem.schedule.map((slot: any, index: number) => (
              <div key={index} className="badge bg-light text-dark border">
                <strong>{slot.day}</strong> • {slot.time}
              </div>
            ))}
          </div>
        </div>

        {/* Quick Actions */}
        <div className="row g-2">
          <div className="col-md-3 col-sm-6">
            <Link
              to={routes.attendanceTracker}
              className="btn btn-success btn-sm w-100"
            >
              <i className="ti ti-user-check me-1"></i>
              Attendance
            </Link>
          </div>
          <div className="col-md-3 col-sm-6">
            <Link
              to={routes.manageHomework}
              className="btn btn-warning btn-sm w-100"
            >
              <i className="ti ti-book me-1"></i>
              Homework
            </Link>
          </div>
          <div className="col-md-3 col-sm-6">
            <Link
              to={routes.gradeEntry}
              className="btn btn-primary btn-sm w-100"
            >
              <i className="ti ti-clipboard-list me-1"></i>
              Grades
            </Link>
          </div>
          <div className="col-md-3 col-sm-6">
            <Link
              to={routes.alertParents}
              className="btn btn-info btn-sm w-100"
            >
              <i className="ti ti-bell me-1"></i>
              Alert
            </Link>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Header */}
          <div className="row mb-4">
            <div className="col">
              <h3 className="page-title mb-2">My Classes</h3>
              <p className="text-muted mb-0">
                Manage all your teaching assignments
              </p>
            </div>
          </div>

          {/* Summary Cards */}
          <div className="row mb-4">
            <div className="col-md-3 col-sm-6">
              <div className="card bg-primary-light">
                <div className="card-body text-center">
                  <div className="avatar avatar-lg bg-primary mb-2">
                    <i className="ti ti-book-2 text-white fs-2"></i>
                  </div>
                  <h4 className="text-primary">{classesData.length}</h4>
                  <p className="mb-0">Total Classes</p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6">
              <div className="card bg-success-light">
                <div className="card-body text-center">
                  <div className="avatar avatar-lg bg-success mb-2">
                    <i className="ti ti-users text-white fs-2"></i>
                  </div>
                  <h4 className="text-success">
                    {classesData.reduce(
                      (sum, cls) => sum + cls.studentsCount,
                      0
                    )}
                  </h4>
                  <p className="mb-0">Total Students</p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6">
              <div className="card bg-warning-light">
                <div className="card-body text-center">
                  <div className="avatar avatar-lg bg-warning mb-2">
                    <i className="ti ti-book text-white fs-2"></i>
                  </div>
                  <h4 className="text-warning">
                    {classesData.reduce(
                      (sum, cls) => sum + cls.homework.pending,
                      0
                    )}
                  </h4>
                  <p className="mb-0">Pending Homework</p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6">
              <div className="card bg-info-light">
                <div className="card-body text-center">
                  <div className="avatar avatar-lg bg-info mb-2">
                    <i className="ti ti-percentage text-white fs-2"></i>
                  </div>
                  <h4 className="text-info">
                    {Math.round(
                      classesData.reduce(
                        (sum, cls) => sum + cls.attendance.percentage,
                        0
                      ) / classesData.length
                    )}
                    %
                  </h4>
                  <p className="mb-0">Avg Attendance</p>
                </div>
              </div>
            </div>
          </div>

          {/* Search and Filter */}
          <div className="card mb-4">
            <div className="card-body">
              <div className="row g-3">
                <div className="col-md-8">
                  <div className="position-relative">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search classes by code or subject..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <i className="ti ti-search position-absolute top-50 end-0 translate-middle-y me-3"></i>
                  </div>
                </div>
                <div className="col-md-4">
                  <select
                    className="form-select"
                    value={filterGrade}
                    onChange={(e) => setFilterGrade(e.target.value)}
                  >
                    {grades.map((grade) => (
                      <option key={grade} value={grade}>
                        {grade === "all" ? "All Grades" : `Grade ${grade}`}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>

          {/* Classes List */}
          <div className="classes-list">
            {filteredClasses.length > 0 ? (
              filteredClasses.map(renderClassCard)
            ) : (
              <div className="card">
                <div className="card-body text-center py-5">
                  <div className="avatar avatar-xl bg-secondary-transparent mb-3">
                    <i className="ti ti-book-2 fs-1 text-secondary"></i>
                  </div>
                  <h5>No classes found</h5>
                  <p className="text-muted">
                    {searchTerm || filterGrade !== "all"
                      ? "Try adjusting your search or filter criteria."
                      : "You haven't been assigned any classes yet."}
                  </p>
                  {searchTerm && (
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        setSearchTerm("");
                        setFilterGrade("all");
                      }}
                    >
                      Clear Search
                    </button>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default TeacherClasses;
